import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import {
	Button,
	Image,
	Input,
	message,
	Modal,
	Popconfirm,
	Tabs,
	Upload,
} from "antd";
import {
	ArrowLeftOutlined,
	EditOutlined,
	LinkOutlined,
} from "@ant-design/icons";
import cart from "../../assets/images/cart.png";
import {
	currencyFormat,
	fallbackString,
	isEmpty,
	Toast,
} from "../../lib/helpers/helpers";
import { currency } from "../../lib/helpers/currencySymbol";
import { btnStyle, inputStyle } from "../../lib/styles/styleLibrary";
import { COLORS } from "../../lib/styles/styles";
// import share from "../../assets/svg/share2.svg";
import send from "../../assets/svg/send2.svg";
import del from "../../assets/svg/del.png";
import { EmptyData, Loading, PageLoading } from "..";
import Auth from "../../lib/middleware/auth";
import plus from "../../assets/svg/plus.svg";
import delFilled from "../../assets/svg/del_filled.png";
import {
	FacebookShareButton,
	TelegramShareButton,
	TwitterShareButton,
	WhatsappShareButton,
	FacebookIcon,
	TelegramIcon,
	TwitterIcon,
	WhatsappIcon,
} from "react-share";
import { useMutation } from "react-query";
import errorHandler from "../../redux/actions/errorHandler";
import {
	deleteGift,
	deleteGiftimg,
	editGiftItem,
} from "../../redux/actions/registry";
import Currency from "../Currency/Currency";
import API_MAP from "../../services/uri";
import axios from "axios";
import { useMediaQuery } from "react-responsive";

const ItemWrapper = styled.div`
	${tw`flex flex-col flex-wrap gap-2`}
	input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type="number"] {
		-moz-appearance: textfield;
	}
	.ant-input-number-input {
		${tw`border-none! focus:(ring-0 ring-transparent ring-opacity-0) hover:border-none`}
	}

	.btn-group {
		position: relative;
		button {
			${tw`rounded-none text-white`}
			background: rgba(50, 50, 50, 0.801);
		}
	}

	.ant-tabs-tab {
		${tw`font-bold text-xs md:text-base hover:text-appPink`}
	}
	.ant-tabs-nav {
		&::before {
			border-bottom: none !important;
		}
	}

	.ant-tabs-nav-list {
		width: 100% !important;
		justify-content: space-evenly;
		overflow-x: scroll;
		-ms-overflow-style: none !important; /* IE and Edge */
		scrollbar-width: none !important;
		&::-webkit-scrollbar {
			display: none !important;
		}

		@media (max-width: 1217px) {
			justify-content: flex-start;
		}
	}

	.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
		color: ${COLORS.appTextDark}; //#323232;
		text-shadow: 0 0 0.25px currentColor;
	}
	.ant-tabs-ink-bar {
		${tw`bg-appTextDark`}
	}
	.ant-tabs-content-holder {
		${tw`h-full overflow-y-scroll`}
		height: 15rem;
	}
`;

const Thumbnail = styled.div`
	${tw`flex items-center justify-center shadow-md`}
	min-width: 125px;
	min-height: 125px;
	max-width: 125px;
	max-height: 125px;
	border-radius: 10px;
	background-color: #ddd;
	${({ bg }) => bg && `background: url(${bg});`};
	background-size: cover !important;
	background-position: center !important;
	background-repeat: no-repeat !important;
`;

const GiftItem = (props) => {
	const {
		item,
		togView = () => {
			return null;
		},
		weddingID,
		refetch,
	} = props;
	const isMobile = useMediaQuery({ maxWidth: 1217 });
	const { TextArea } = Input;
	const experience = Auth.getExperience();
	const curr = Auth.getCurrency();
	const [visible, setVisible] = useState(false);
	const [shareVisible, setShareVisible] = useState(false);
	const [editVisible, setEditVisible] = useState(false);
	const [selecteimg, setSelectedimg] = useState("");
	const [imageUrls, setImageUrls] = useState([]);
	const [imageUrl, setImageUrl] = useState([]);
	const [selectedUrl, setSelectedUrl] = useState("");
	const [showupload, setShowUpload] = useState(true);
	const [defaultFileList, setDefaultFileList] = useState([]);
	const [quantity, setQuantity] = useState(1);
	const [newItem, setNewItem] = useState({
		giftId: item?.id,
		price: item?.price,
		description: item?.description,
		gift_link: item?.gift_link,
		currencyId: curr?.id,
		images: [],
		quantity: quantity,
	});
	const { TabPane } = Tabs;

	const up = (i) => {
		if (quantity > 0 && quantity < remainingQuantity) {
			setQuantity(quantity + 1);
		}
	};
	const down = (i) => {
		if (quantity !== 1) {
			setQuantity(quantity - 1);
		}
	};
	useEffect(() => {
		setNewItem({
			...newItem,
			giftId: item?.id,
			price: item?.price,
			description: item?.description,
			gift_link: item?.gift_link,
			currencyId: curr?.id,
			quantity: quantity,
		});
		setImageUrl(item?.wedding_gifts_images);
		// eslint-disable-next-line
	}, [item?.wedding_gifts_images]);

	useEffect(() => {
		setNewItem({ ...newItem, images: imageUrls });
		// eslint-disable-next-line
	}, [imageUrls]);

	// console.log(imageUrls);

	const remainingQuantity = item.quantity_requested - item.quantity_fulfilled;
	// console.log(item, quantity, remainingQuantity);
	const fallback = fallbackString(cart);

	const handlePrevious = () => {
		togView(false);
	};

	const { mutateAsync: delGift, isLoading: delloading } =
		useMutation(deleteGift);

	const handleDelete = async () => {
		try {
			const response = await delGift(item.id);
			console.log(response.data);
			const { hasError } = response.data;
			if (hasError) {
				console.log(response);
				const { title, message } = response.data.errors;
				return Toast.fire({
					icon: "error",
					title: `${title}\n${message}`,
				});
			}
			Toast.fire({
				icon: "success",
				title: `${response.data.data}`,
			});
			refetch();
			togView(false);
		} catch (err) {
			return errorHandler(err);
		}
	};

	const { mutateAsync: delGiftimg, isLoading: delimgloading } =
		useMutation(deleteGiftimg);

	const handleRemoveimg = async () => {
		const credential = {
			giftID: item.id,
			imageID: selecteimg,
		};
		try {
			const response = await delGiftimg(credential);
			console.log(response.data);
			const { hasError } = response.data;
			if (hasError) {
				console.log(response);
				const { title, message } = response.data.errors;
				return Toast.fire({
					icon: "error",
					title: `${title}\n${message}`,
				});
			}
			Toast.fire({
				icon: "success",
				title: `Image removed from item`,
			});
			setImageUrl(response.data?.data?.wedding_gifts_images);
			// togView(false);
		} catch (err) {
			return errorHandler(err);
		}
	};

	const { mutateAsync: editGift, isLoading: editloading } =
		useMutation(editGiftItem);

	const handleEditGift = async () => {
		console.log(newItem);
		try {
			const response = await editGift(newItem);
			console.log(response.data);
			const { hasError } = response.data;
			if (hasError) {
				console.log(response);
				const { title, message } = response.data.errors;
				return Toast.fire({
					icon: "error",
					title: `${title}\n${message}`,
				});
			}
			Toast.fire({
				icon: "success",
				title: `Gift item updated`,
			});
			refetch();
			togView(false);
			setEditVisible(false);
			setImageUrls([]);
		} catch (err) {
			return errorHandler(err);
		}
	};

	const handleFileChange = ({ fileList }) => {
		// Processing file Change, guaranteed that the user selected by one is only one
		setDefaultFileList(fileList);
	};
	// console.log(defaultFileList);

	const handleUpload = async (options) => {
		const { onSuccess, onError, file } = options;
		if (isEmpty(defaultFileList)) {
			message.warning("Please select the file you want to upload");
		}
		setShowUpload(true);
		const formData = new FormData();
		const config = {
			headers: { "content-type": "multipart/form-data" },
		};
		formData.append("media", file);
		axios
			.post(
				`${API_MAP.UploadWeddingGift}?weddingId=${weddingID}`,
				formData,
				config
			)
			.then(({ data }) => {
				onSuccess("Ok");
				// console.log("upload server res: ", data);
				const { hasError } = data;
				if (hasError) {
					return Toast.fire({
						icon: "error",
						title: data.errors.message,
					});
				}
				const { media_records } = data.data;
				imageUrls.push(media_records[0].media_url);

				// newItem?.images.push(media_records[0].media_url);
				setDefaultFileList([]);

				setShowUpload(false);
				// message.success(data.message);
			})
			.catch((err) => {
				console.log("Error: ", err);
				onError({ err });
			});
	};

	return (
		<ItemWrapper>
			{delloading && <PageLoading />}
			<div
				tw="mb-4 h-8 w-8 px-2 py-2 bg-gray-100 rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800) flex flex-col items-center justify-center"
				onClick={handlePrevious}>
				<ArrowLeftOutlined tw="hover:(text-purple-800 transform scale-125)" />
			</div>

			<div tw="flex flex-col gap-2 w-full">
				<div tw="relative h-96">
					<Image
						preview={{ visible: false }}
						onClick={() => setVisible(true)}
						src={item?.wedding_gifts_images[0]?.media_url || cart}
						alt={item.name}
						width={"100%"}
						height={"100%"}
						fallback={`data:image/png;base64,${fallback}`}
						tw="rounded-2xl shadow-md bg-gray-200 min-w-full"
						placeholder={
							<Image
								preview={false}
								src={
									item?.wedding_gifts_images[0]
										?.media_url_min || cart
								}
								width={200}
							/>
						}
					/>
					<div style={{ display: "none" }}>
						<Image.PreviewGroup
							preview={{
								visible,
								onVisibleChange: (vis) => setVisible(vis),
							}}>
							{item?.wedding_gifts_images?.map((img, i) => {
								// console.log(img);
								return (
									<Image
										key={i}
										// preview={false}
										src={img?.media_url || cart}
										alt={item.name}
										width={180}
										height={195}
										fallback={`data:image/png;base64,${fallback}`}
										tw="rounded-2xl shadow-md bg-gray-200 min-h-full min-w-full"
										placeholder={
											<Image
												preview={false}
												src={img.media_url_min || cart}
												width={200}
											/>
										}
									/>
								);
							})}
						</Image.PreviewGroup>{" "}
					</div>

					<div className="btn-group w-full">
						<div tw="inline-flex absolute bottom-4 w-full! items-center justify-center">
							<Button
								tw="rounded-tl-md! rounded-bl-md!"
								onClick={down}>
								-
							</Button>
							<input
								type="number"
								value={quantity}
								min={0}
								max={item?.quantity_requested}
								onChange={(e) => {
									setQuantity(e.target.value);
									setNewItem({
										...newItem,
										quantity: e.target.value,
									});
								}}
								tw="w-8 p-0 h-8 border-none! text-center cursor-default! text-appTextDark! bg-white! font-bold hover:(border-none)"
							/>

							<Button
								tw="rounded-tr-md! rounded-br-md!"
								onClick={up}>
								+
							</Button>
						</div>
					</div>
				</div>
				<div tw="flex flex-col justify-between w-full gap-2">
					<div tw="mt-4 flex flex-row justify-between flex-wrap items-center">
						<p tw="text-base md:text-2xl text-appTextFaded font-semibold">
							{item.name}
						</p>
						<p tw="text-base md:text-2xl font-extrabold">
							{currency()} {currencyFormat(item.price)}
						</p>
					</div>
					{experience !== "couple" ? (
						<button
							css={btnStyle}
							tw="rounded-md w-full"
							onClick={() => {
								message.info(
									"You are being redirected to the product page"
								);
								setTimeout(() => {
									window.open(`${item.gift_link}`, "_blank");
								}, 1200);
							}}>
							GIFT NOW
						</button>
					) : (
						<div tw="flex flex-row items-center justify-around">
							<Image
								preview={false}
								src={send}
								width={40}
								height={40}
								tw="p-2 bg-appLightPink rounded-md hover:(shadow-lg p-2.5 cursor-pointer)"
								onClick={() => setShareVisible(true)}
							/>
							<Popconfirm
								placement="top"
								title={"Are you sure to delete this gift?"}
								onConfirm={handleDelete}
								okText="Yes"
								cancelText="No">
								<Image
									preview={false}
									src={del}
									width={40}
									height={40}
									tw="p-2 bg-appLightPink  rounded-md hover:(shadow-lg p-2.5 cursor-pointer)"
								/>
							</Popconfirm>

							<EditOutlined
								tw="bg-appLightPink h-12 w-10 text-2xl text-appPink p-2 rounded-md hover:(shadow-lg p-1.5 cursor-pointer)"
								onClick={() => setEditVisible(true)}
							/>
						</div>
					)}
				</div>
			</div>
			<div tw="mt-4 w-full">
				<Tabs defaultActiveKey="1" tabPosition={"top"} animated>
					<TabPane tab="Description" key="1">
						<div tw="p-2 whitespace-pre-wrap">
							{isEmpty(item.description) ? (
								<div tw="h-full flex flex-col items-center justify-center">
									<EmptyData description="No data" />
								</div>
							) : (
								item.description
							)}
						</div>
					</TabPane>
				</Tabs>
			</div>

			<Modal
				footer=""
				visible={shareVisible}
				centered
				onCancel={() => setShareVisible(false)}
				maskClosable={false}>
				<h3 tw="text-lg font-extrabold text-appTextDark opacity-90 capitalize mb-4">
					Share gift on:
				</h3>
				<div tw="flex flex-row items-center justify-evenly flex-wrap gap-4">
					<FacebookShareButton
						// url={item.gift_link}
						openShareDialogOnClick={true}>
						<FacebookIcon
							tw="shadow hover:shadow-lg rounded-full"
							round
							size={45}
						/>
					</FacebookShareButton>
					<TelegramShareButton
						// url={item.gift_link}
						openShareDialogOnClick={true}>
						<TelegramIcon
							tw="shadow hover:shadow-lg  rounded-full"
							round
							size={45}
						/>
					</TelegramShareButton>
					<TwitterShareButton
						// url={item.gift_link}
						openShareDialogOnClick={true}>
						<TwitterIcon
							tw="shadow hover:shadow-lg  rounded-full"
							round
							size={45}
						/>
					</TwitterShareButton>
					<WhatsappShareButton
						// url={item.gift_link}
						openShareDialogOnClick={true}>
						<WhatsappIcon
							tw="shadow hover:shadow-lg rounded-full"
							round
							size={45}
						/>
					</WhatsappShareButton>
				</div>
			</Modal>
			<Modal
				footer=""
				visible={editVisible}
				centered
				width={isMobile ? "100%" : "50%"}
				onCancel={() => setEditVisible(false)}
				maskClosable={false}>
				{/* the modal side start */}

				<ItemWrapper>
					<div tw="flex flex-col gap-2 w-full">
						<div tw="relative ">
							<div tw="mb-4">
								<div tw="flex flex-row gap-3 mt-4 flex-wrap">
									{imageUrl?.map((m, i) => {
										return (
											<Thumbnail
												bg={m?.media_url_min || cart}
												key={i}
												onClick={() =>
													setSelectedimg(m?.id)
												}
												css={
													selecteimg === m?.id &&
													delimgloading && {
														opacity: "0.6",
													}
												}>
												<Popconfirm
													placement="bottom"
													title={`Delete this image from Gift item?`}
													onConfirm={() => {
														if (
															selecteimg === m.id
														) {
															handleRemoveimg();
														}
													}}
													okText="Ok"
													cancelText="Back">
													<span
														className="delBg"
														tw="flex items-center bg-white p-3 rounded-full justify-center hover:cursor-pointer">
														<Image
															preview={false}
															src={delFilled}
															alt=""
															width={14}
															height={14}
															tw="rounded-md bg-white"
														/>
													</span>
												</Popconfirm>
											</Thumbnail>
										);
									})}
									{imageUrls?.map((url, i) => {
										// console.log(url);
										return (
											<Thumbnail
												bg={url || cart}
												key={i}
												onClick={() =>
													setSelectedUrl(url)
												}>
												<Popconfirm
													placement="bottom"
													title={`Remove this image?`}
													onConfirm={() => {
														selectedUrl === url &&
															message.success(
																"Image removed"
															);
														return setImageUrls(
															imageUrls.filter(
																(file) => {
																	return (
																		url !==
																		file
																	);
																}
															)
														);
													}}
													okText="Ok"
													cancelText="Back">
													<span
														className="delBg"
														tw="flex items-center justify-center hover:cursor-pointer">
														<Image
															preview={false}
															src={delFilled}
															alt=""
															width={14}
															height={15}
															tw="rounded-md"
														/>
													</span>
												</Popconfirm>
											</Thumbnail>
										);
									})}
								</div>
							</div>

							<div tw="mt-8 mb-4">
								<Upload
									defaultFileList={defaultFileList}
									accept="image/*"
									onChange={handleFileChange}
									customRequest={handleUpload}
									maxCount={1}
									showUploadList={showupload}>
									{imageUrls.length >= 10 ? null : (
										<Button
											size="large"
											className="btnStyle"
											tw="h-auto py-4 bg-white rounded flex flex-col items-center justify-between gap-2">
											<div tw="flex flex-col items-center justify-center gap-2">
												<Image
													preview={false}
													src={plus}
													alt=""
													width={25}
													height={25}
												/>
												<span tw="opacity-60 text-xs">
													Upload your image
												</span>
											</div>
										</Button>
									)}
								</Upload>
							</div>
						</div>
					</div>

					<div tw="flex flex-row flex-nowrap gap-4 w-full">
						<span tw="mt-3">
							<Currency changeUserDefault={false} />
						</span>
						<Input
							placeholder="Amount"
							type="number"
							css={inputStyle}
							min={0}
							value={newItem.price}
							onChange={(e) =>
								setNewItem({
									...newItem,
									price: e.target.value,
								})
							}
							tw="w-full text-xs! px-3 py-6 rounded-md"
						/>
					</div>
					<div tw="mt-4">
						<Input
							placeholder="Enter link to gift item"
							type="url"
							css={inputStyle}
							min={0}
							value={newItem.gift_link}
							onChange={(e) =>
								setNewItem({
									...newItem,
									gift_link: e.target.value,
								})
							}
							tw="w-full text-xs! rounded-md"
							prefix={<LinkOutlined tw="text-base pr-2" />}
						/>
					</div>

					<div tw="mt-4">
						<TextArea
							placeholder="Description"
							autoSize={{ minRows: 6 }}
							tw="mb-4 text-xs p-3 rounded-lg"
							value={newItem.description}
							onChange={(e) =>
								setNewItem({
									...newItem,
									description: e.target.value,
								})
							}
						/>
					</div>

					<div tw="mt-8 mb-8">
						<button
							css={btnStyle}
							tw="rounded-md"
							onClick={handleEditGift}>
							{editloading ? <Loading /> : "Edit"}
						</button>
					</div>
				</ItemWrapper>

				{/* the modal side end */}
			</Modal>
		</ItemWrapper>
	);
};

export default GiftItem;
